import { HTTPRequestMethods } from '@enums/HTTPRequestMethods'
import { errorWithStack } from '@utils/logger'

export const searchCars = async (query: string, cityName: string) => {
  try {
    const url = `/api/catalog/search/?query=${encodeURIComponent(query)}&cityName=${encodeURIComponent(cityName)}`

    const response = await fetch(url, {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    errorWithStack('Error fetching cars search:', error)
    return []
  }
}

export const searchBlogs = async (query: string) => {
  try {
    let url = '/api/catalog/search-articles/'

    if (query?.trim()) {
      url += `?query=${encodeURIComponent(query)}`
    }

    const response = await fetch(url, {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    errorWithStack('Error searching blogs:', error)
    return []
  }
}
